export const budget = 'budget';
export const currency = 'currency';
export const education = 'education';
export const experience = 'experience';
export const grossnet = 'grossnet';
export const language = 'language';
export const languageLevel = 'languageLevel';
export const schedule = 'schedule';
export const sex = 'sex';
export const reason = 'reason';
export const workplace = 'workplace';
export const worktype = 'worktype';
export const yesno = 'yesno';
export const mrktclienttype = 'mrktclienttype';
export const localStorageRequestFormKey = 'requestForm';
export const limits = 'limits';

export const metroTown = 'MetroTownList';
export const metroRegion = 'MetroRegionList';
export const metroDepartment = 'MetroDepartments';
export const metroDepartmentChildren = 'metroDepartmentChildren';
export const metroCell = 'MetroCell';
export const metroStore = 'MetroStoreList';
export const metroDirectorats = 'MetroDirectorates';
export const metroUnits = 'MetroUnits';
export const metroDivision = 'MetroDivisionList';
export const metroPositions = 'MetroPositions';
export const metroOccupationType = 'MetroOccupationType';
export const metroEmploymentType = 'PrjEmployType';
export const metroChartOfWork = 'PrjChartOfWork';
export const metroGrades = 'MetroGrades';
export const metroPositionLevels = 'MetroPositionLevels';
export const metroBonusSchema = 'MetroBonusSchema';
export const metroDirectorateDecision = 'MetroDirectorateDecision';
export const metroCompanyCar = 'MetroCompanyCar';
export const metroRecruiters = 'MetroRecruiters';
export const metroHRGeneralist = 'MetroHRGeneralist';
export const metroHRM = 'MetroHRM';
export const metroHRBP = 'MetroHRBP';
export const metroHRBPOperations = 'MetroHRBPOperations';
export const metroBonusPercent = 'MetroBonusPercent';
export const metroHQ = 'MetroHQList';
export const yesnocombo = 'YesNoCombo';
export const metroCompetence = 'MetroCompetence';
export const metroUsers = 'MetroAllSotrList';

export const REPLACE_CODES = [7006, 458758];
export const YES_CODE = 1;
